import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ContentViewerErrorState from '@/content-viewer/components/common/ContentViewerErrorState'
import WritingSamplePdfRenderer from '@/content-viewer/components/agent-reference/renderers/WritingSamplePdfRenderer'
import { kUnnamedWritingSampleFallback } from '@/agent/references/constants'
import { useTitle } from '@/hooks/use-title'
import { brandedAIFriendlyName } from '@/util/enterprise'

export default function StandaloneReferenceViewerWritingSamplePage() {
  const { matterId = '', referenceId = '' } = useParams<{ matterId: string; referenceId: string }>()
  const [title, setTitle] = useState(kUnnamedWritingSampleFallback)

  useTitle(title === kUnnamedWritingSampleFallback ? `${brandedAIFriendlyName} Reference Viewer` : title)

  useEffect(() => {
    setTitle(kUnnamedWritingSampleFallback)
  }, [matterId, referenceId])

  if (!matterId || !referenceId) {
    return (
      <div className="grow flex flex-col h-full pb-4 pt-8">
        <div className="pl-2">
          <ContentViewerErrorState message="Could not load this writing sample." />
        </div>
      </div>
    )
  }

  return (
    <div className="grow flex flex-col h-full overflow-y-scroll pb-4 pt-8">
      <div className="w-full max-w-5xl mx-auto flex flex-col h-full min-h-0 gap-4">
        <div className="pl-2 flex items-center justify-between gap-4">
          <h1 className="text-xl font-bold leading-7 truncate text-brand-neutral-950">{title}</h1>
        </div>

        <div className="min-h-0 flex-1 bg-white border border-brand-neutral-200">
          <WritingSamplePdfRenderer
            referenceId={referenceId}
            matterId={matterId}
            title={kUnnamedWritingSampleFallback}
            onFileNameLoaded={setTitle}
            loadingSize="large"
          />
        </div>
      </div>
    </div>
  )
}
